export const MemberCardDisplayMode = {
  Create: {
    ActionType: 'Create',
    ActionComplete: 'Create',
    ActionCancel: 'Cancel'
  },
  Edit: {
    ActionType: 'Edit',
    ActionComplete: 'Done',
    // Should be 'Remove' when members removal is implemented
    ActionCancel: 'Cancel'
  }
}



// WEBPACK FOOTER //
// ./src/infra/MemberCardDisplayMode.js